import { render, staticRenderFns } from "./simulator.vue?vue&type=template&id=c811d3ce&scoped=true"
import script from "./simulator.vue?vue&type=script&lang=js"
export * from "./simulator.vue?vue&type=script&lang=js"
import style0 from "./simulator.vue?vue&type=style&index=0&id=c811d3ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c811d3ce",
  null
  
)

export default component.exports